// Components==============
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { HomeContext } from 'screens/Home/Home';
import { initialPulse, pulse } from 'utilities/framerAnimations';
import { MenuContext } from '../../Menu';
import Popup from '../Popup/Popup';
import Step from './components/Step/Step';
import './Steps.module.scss';
// =========================

const A = Array(5).fill('A');
const B = Array(5).fill('B');

export default function Steps() {
    const { select, selected, setMenuPointer } = useContext(MenuContext);

    const { setWelcomeY, welcomeSequence } = useContext(HomeContext);

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (welcomeSequence === 'stappenplan') {
            setWelcomeY(`${ref?.current?.offsetTop!}px`);
        }
    }, [welcomeSequence]);

    const treatment = useSelector((state: ReduxStore) => {
        const treatments = state?.treatment?.entities.allIds.map(
            (treatmentId) => state?.treatment?.entities.byId[treatmentId]
        );
        const activeTreatment = treatments?.find((t) => t?.pivot?.open);
        return activeTreatment;
    });

    let current = treatment?.stappenplan || 'A';
    current = current.toUpperCase();

    return (
        <div styleName="wrapper" ref={ref}>
            <motion.button
                animate={
                    welcomeSequence === 'stappenplan' ? pulse : initialPulse
                }
                initial={initialPulse}
                onClick={(e) => {
                    select('steps');
                    setMenuPointer(e);
                }}
                type="button"
            >
                <img alt="steps icon" src="/images/menu/icon-steps.svg" />
            </motion.button>
            {selected === 'steps' && (
                <Popup>
                    <div styleName="inner-wrapper">
                        {current === 'A'
                            ? A.map((type, i) => (
                                  <Step type={type} step={i + 1} key={i} />
                              ))
                            : B.map((type, i) => (
                                  <Step type={type} step={i + 1} key={i} />
                              ))}
                    </div>
                </Popup>
            )}
        </div>
    );
}
